import { PropsWithChildren } from "react";
import { animated, useSpring } from "react-spring";

import { Box, useTheme } from "@mui/material";
import { Step } from "@covertree/layouts";

interface AnimationBoxProps {
  currentStep: Step<unknown>;
}

export function AnimationBox({
  children,
  currentStep,
}: PropsWithChildren<AnimationBoxProps>) {
  const theme = useTheme();

  const [styleProps] = useSpring(
    () => ({
      from: {
        opacity: 0,
        top: "50vh",
      },
      to: { opacity: 1, top: "0px" },
      reset: true,
    }),
    [currentStep]
  );

  return (
    <Box position="relative" width="100%" height="max-content">
      <animated.div
        style={{
          width: "100%",
          position: "absolute",
          paddingBottom: theme.spacing(2),
          ...styleProps,
        }}>
        {children}
      </animated.div>
    </Box>
  );
}
